<template>
  <div class="box">
    <div class="top">
      <div class="text1">阿里询盘提醒-旺信通</div>
      <div class="text2">新用户订购折上再八折</div>
      <div class="text3">另每月赠送200条短信+50分钟通话</div>
      <img @click="payButton('一年领劵购买')" class="RD_NewUserImage1" :src="$OSSBaseUrl+'RD_NewUserImage1.png'">
      <img @click="payButton('季度领劵购买')" class="RD_NewUserImage2" :src="$OSSBaseUrl+'RD_NewUserImage2.png'">
    </div>
    <div>
      <div class="button">
        <img class="button_icon" :src="$OSSBaseUrl+'1688_kefu_log.png'">
        <span>
          ps：点击领券购买 跳转至1688服务市场
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { URL7, URL8 } from "@/utils/Redirect";
export default {
  name:"Upgrade_RD",
  data(){
    return{
      mark: ''
    }
  },
  methods:{
    payButton(mark){
      this.mark = mark
      this.$store.dispatch("CouponPage/receiveVisitorCoupon", {}).then((res) => {
        this.inH5Record()
      })
      
    },
    inH5Record() {
      let data = {
          page_from:'main_page',
          page_name:'Upgrade_RD',
          btn_name: this.mark,
          page_time:'0.00',
          receiver_id: '',
          page_param:{},
      };
      this.$store.dispatch('Public/inH5Record', data).then(res=>{
        if(this.mark=="一年领劵购买"){
          window.location.href=URL8
        }
        if(this.mark=="季度领劵购买"){
          window.location.href=URL7
        }
        
      })
    }
  }
}
</script>
<style lang="scss" src="./index.scss" scoped></style>